import type { Program } from '../types/content';
import { photos } from './site';

export const programs: Program[] = [
  {
    id: 'little-braves',
    name: 'Little Braves',
    audience: 'Ages 3–5',
    summary: 'A first taste of Taekwondo built around listening, balance and doing things on their own.',
    description:
      'Little Braves introduces young children to Taekwondo through simple, achievable challenges. Students learn to listen for the next instruction, move with control, and try new skills with growing independence.',
    practices: ['Listening and following directions', 'Coordination and balance', 'Independence and trying on their own'],
    goodFit: 'Children ages 3 to 5, including those starting their very first structured activity.',
    ctaLabel: 'Book a Little Braves trial',
    image: photos.littleBraves,
    imageAlt: 'Four young Bates Taekwondo students standing together in their uniforms',
    imagePosition: '50% 50%',
    imageFit: 'contain',
  },
  {
    id: 'kids',
    name: 'Kids Taekwondo',
    audience: 'Kids',
    summary: 'Real Taekwondo skills that build focus, confidence and effort, alongside friends.',
    description:
      'Kids classes teach Olympic-style Taekwondo technique while giving each child clear goals to work toward. Students practice paying attention, putting in real effort, and encouraging the classmates training beside them.',
    practices: ['Focus during drills and instruction', 'Confidence through new skills', 'Effort and persistence', 'Friendship and teamwork'],
    goodFit: 'Children past the Little Braves age, from first-timers to students with some experience.',
    ctaLabel: 'Book a Kids trial',
    image: photos.team,
    imageAlt: 'Bates Taekwondo students gathered together as a team',
    imagePosition: '50% 85%',
  },
  {
    id: 'teens-adults',
    name: 'Teens & Adults',
    audience: 'Teens & adults',
    summary: 'Solid technique, real fitness and a challenge that keeps growing with you.',
    description:
      'Teen and adult classes focus on Olympic-style Taekwondo skills and conditioning. Coaching meets you at your current level, so beginners can start comfortably and experienced students keep progressing.',
    practices: ['Kicking technique and footwork', 'Fitness and conditioning', 'Progressive challenge at your own pace'],
    goodFit: 'Teens and adults who want to learn something new, get fit, or return to training.',
    ctaLabel: 'Book a Teens & Adults trial',
    image: photos.adultsTraining,
    imageAlt: 'Two adult students practicing a high kick, with both faces and their training positions visible',
    imagePosition: '50% 50%',
    imageFit: 'contain',
  },
  {
    id: 'competition-team',
    name: 'Competition Team',
    audience: 'Additional pathway',
    summary: 'For committed athletes who want to train for tournament Taekwondo.',
    description:
      'The Competition Team is an additional pathway for students who want to compete. It builds on regular classes with focused coaching for tournament Taekwondo. It is a choice for interested athletes, never a requirement.',
    practices: ['Competition-focused technique', 'Preparing for tournaments', 'Training alongside committed teammates'],
    goodFit: 'Students who are committed to training and interested in competing. Ask the school about joining.',
    ctaLabel: 'Ask about the Competition Team',
    image: photos.advancedCompetition,
    imageAlt: 'Advanced Taekwondo competitors exchanging a high kick during a tournament match',
    imagePosition: '50% 50%',
    imageFit: 'contain',
  },
];
